import { render } from "./RegistrationForm.vue?vue&type=template&id=4864e03b&scoped=true"
import script from "./RegistrationForm.vue?vue&type=script&lang=js"
export * from "./RegistrationForm.vue?vue&type=script&lang=js"

import "./RegistrationForm.vue?vue&type=style&index=0&id=4864e03b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4864e03b"]])

export default __exports__